import { createContext } from 'react';
import ability from 'common/casl/ability';
import { createContextualCan, createCanBoundTo } from '@casl/react';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

export const AbilityContext = createContext();
/**
 * Create Can component to validate user permission
 *
 *
 */

export const MyCan = createCanBoundTo(ability);
export const Can = createContextualCan(AbilityContext.Consumer);

export { ABILITY_ACTION, ABILITY_SUBJECT };
